const { REACT_APP_ASSIST_API_URL, REACT_APP_ASSIST_API_TOKEN } = process.env;

export const handleServiceUp = {
  headers: {
    emquest_access_token: REACT_APP_ASSIST_API_TOKEN,
  },
  apiUrl: REACT_APP_ASSIST_API_URL + "/system/service_status/AGENT/up",
};

export const handleServiceDown = {
  headers: {
    emquest_access_token: REACT_APP_ASSIST_API_TOKEN,
  },
  apiUrl: REACT_APP_ASSIST_API_URL + "/system/service_status/AGENT/down",
};
